// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Znqv","label":"styles_label__2B9K2"};